function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { PureComponent } from 'react';
import RateTable from '../Pricing/ReviewRates/RateTable.js';
import * as Theme from '../../theme/index.js';
import Text from '../../components/Text.js';
import Button from '../../components/Button.js';
import { useTheme } from '@mui/system';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';

/**
 * 
 * @param {*} props 
 * @returns 
 */
const SelectedTile = props => {
  const theme = useTheme();
  const {
    children,
    selected
  } = props;
  const style = {
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
    background: '#FFF',
    border: selected && `3px solid ${theme.palette.primary.main}`,
    width: '254px',
    height: '130px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    margin: '8px',
    position: 'relative',
    '&:hover': {
      boxShadow: !selected && '0px 12px 40px rgba(0, 0, 0, 0.15)'
    }
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    style: style
  }), children);
};
class ClassBlock extends PureComponent {
  state = {
    pricing: null,
    showRateTable: false,
    showingRateTableFor: null
  };
  _showRateTable = designID => {
    this.setState({
      pricing: this.props.designs[this.props.classID][designID].pricing,
      showRateTable: true,
      showingRateTableFor: designID
    });
    this.props.onSelect(this.props.classID, designID);
  };
  _hidePricingSummary = () => {
    this.setState({
      pricing: null,
      showRateTable: false,
      showingRateTableFor: null
    });
  };
  render() {
    const {
      assignedPlans,
      classID,
      designs,
      onSelect,
      whitelabel
    } = this.props;
    const styles = {
      contentBlock: {
        backgroundColor: Theme.colors.surface,
        boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
        display: 'block',
        margin: 'auto auto 30px auto',
        padding: '30px',
        position: 'relative',
        zIndex: 3
      },
      container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 30
      }
    };
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      color: whitelabel.primaryColor || Theme.colors.skyBlue
    }, this.props.title), /*#__PURE__*/React.createElement("div", {
      style: styles.container
    }, Object.keys(designs[classID]).map((designID, i) => /*#__PURE__*/React.createElement(SelectedTile, {
      key: i,
      selected: assignedPlans[classID] === designID,
      onClick: () => onSelect(classID, designID)
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true,
      display: "block",
      align: "center",
      marginBottom: 20
    }, `${i18n.t(tokens.titles.design)} ${i + 1}`)), /*#__PURE__*/React.createElement(Button, {
      onClick: () => {
        if (this.state.showRateTable && this.state.showingRateTableFor === designID) {
          this._hidePricingSummary();
        } else {
          this._showRateTable(designID);
        }
      },
      transparent: true,
      customStyle: {
        fontSize: 10,
        padding: 0,
        color: whitelabel.primaryColor || Theme.colors.skyBlue
      }
    }, this.state.showRateTable && this.state.showingRateTableFor === designID ? i18n.t(tokens.labels.planDesign.hideSummary) : i18n.t(tokens.labels.planDesign.viewSummary))))), this.state.showRateTable && /*#__PURE__*/React.createElement("div", {
      style: styles.contentBlock
    }, /*#__PURE__*/React.createElement(RateTable, {
      pricing: this.state.pricing,
      whitelabel: this.props.whitelabel
    })));
  }
}
export default ClassBlock;